// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CommsBanner_wrapper__KojpR","comms":"CommsBanner_comms__DWSJ4","banner":"CommsBanner_banner__3wrlL","comm":"CommsBanner_comm__PUFGq","arrow":"CommsBanner_arrow__vhZ6T"};